import React from 'react';
import Grid from '@material-ui/core/Grid';
import Typography from '@material-ui/core/Typography';

import { useStyles } from './styles';
import { GridSize } from '@material-ui/core/Grid/Grid';

type InfoChartWrapperProps = {
  title: string;
  xs?: GridSize;
};

export const InfoChartWrapper: React.FC<InfoChartWrapperProps> = ({ title, children, xs = 6 }) => {
  const classes = useStyles();
  return (
    <Grid item className={classes.infoChartWrapper} xs={xs}>
      <div className={classes.wrappedContainer}>
        <Typography variant="h4">{title}</Typography>
        {children}
      </div>
    </Grid>
  );
};
